import { render, staticRenderFns } from "./CardXuanke.vue?vue&type=template&id=f806f57c&scoped=true"
import script from "./CardXuanke.vue?vue&type=script&lang=js"
export * from "./CardXuanke.vue?vue&type=script&lang=js"
import style0 from "./CardXuanke.vue?vue&type=style&index=0&id=f806f57c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f806f57c",
  null
  
)

export default component.exports